import axios from "axios";
import { getCookie } from "../getcookie.js";

const apiUrl = process.env.REACT_APP_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
const header={
  'Content-Type': 'application/json; charset=UTF-8',
  "Accept": "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  "Authorization": getCookie("mawalog")
}





export const getCount = async () => {
 
  try {
    const response = await axios.get(
      apiUrl+`dashboard/count`,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getpurpose = async () => {
 
  try {
    const response = await axios.get(
      apiUrl+`dashboard/purpose_based_count`,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getentryBased = async () => {
 
  try {
    const response = await axios.get(
      apiUrl+`dashboard/entry_based_count`,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getoverstaycount = async () => {
 
  try {
    const response = await axios.get(
      apiUrl+`dashboard/overstayed_count`,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getCourierCount = async () => {
 
  try {
    const response = await axios.get(
      apiUrl+`dashboard/courier_status_based_count`,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getregistCount= async () => {
 
  try {
    const response = await axios.get(
      apiUrl+`dashboard/meeting_based_count`,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getMonthlyCount= async () => {
 
  try {
    const response = await axios.get(
      apiUrl+`dashboard/monthly/web`,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const gettodayCount= async () => {
 
  try {
    const response = await axios.get(
      apiUrl+`dashboard/today`,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getAverageApi= async () => {
 
  try {
    const response = await axios.get(
      apiUrl+`dashboard/average_gate_in`,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};





